import React, { Component, createRef } from 'react';
import Types from '../../models/components/loading';
import { Common } from '../../core/common';
import { IAppState, IAction } from '../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { Log } from 'ng2-logger';
import ContentLoader from 'react-content-loader';
import Translator from '../../core/i18n';

let _common: Common;
const _logger = Log.create('Loading.tsx');
const T = Translator.create();

export class CLoading extends React.Component<Types.IStandartPopup, any> {
    _image: HTMLImageElement | null = null;

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    onImageLoadError = () => {
        if (!this._image) return;

        if (this._image.src !== _common.GetDefaultLogos('loader')) {
            this._image.src = _common.GetDefaultLogos('loader');
        }
    };

    public render() {
        const Logo = this.props.ImageUrl ? this.props.ImageUrl : this.props.logo ? this.props.logo : _common.GetDefaultLogos('loader');
        const componentSpacing = 80;
        return (
            this.props.type === 'box' ? 
            <React.Fragment>
                <div
                    id={this.props.spinnerId}
                    className={'site-loading' + this.props.class ? this.props.class : ''}
                    style={{
                        display: 'none',
                        position: this.props.position ? this.props.position : 'relative',
                        bottom: this.props.bottom ? this.props.bottom : 15,
                        textAlign: 'center',
                        zIndex: 999,
                        width: '100%',
                        left: 0,
                        right: 0
                    }}
                >
                    { this.props.children ? this.props.children : <div className="rectangle"><span>{T.t('r_default_loading_message')}</span></div> }
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <div
                    id={this.props.spinnerId}
                    className={'site-loading' + this.props.class ? this.props.class : ''}
                    style={{
                        display: 'none',
                        height: this.props.height ? this.props.height : '100%',
                        width: this.props.width ? this.props.width : ''
                    }}
                >
                    {this.props.children  }
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: Types.IStandartPopup): Types.IStandartPopup => {
    if (!state) {
        return ownProps;
    }
    const newProps: Types.IStandartPopup = Object.assign({}, ownProps, {
        logo: state.login.login.logoPath
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.login.login.logoPath === prev.login.login.logoPath;
    return ret;
};

const Loading = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CLoading);

export default Loading;
